export default __webpack_public_path__ + "static/media/35.4e8f4585.jpg";